import React from 'react';
import Breadcrumb from './Breadcrumb';
import './page-chrome.css';

const PageChrome: React.FC = () => (
  <div className="page-chrome" data-tour="page-breadcrumb">
    <Breadcrumb />
  </div>
);

export default PageChrome;
